import React, { useState } from "react";
import RedeemPointsModal from "../../modal/milesPoints/RedeemPointsModal";

function MilesPointsRedeemCard({ item }) {
  const [modal, setModal] = useState(false);
  return (
    <div className="flex-shrink-0 w-[412px] h-[264px] rounded-lg shadow-md flex flex-col bg-white overflow-hidden border border-gray-300">
      <RedeemPointsModal item={item} open={modal} setOpen={setModal} />
      <div className="flex flex-1 w-full items-center flex-col py-4">
        <div className="flex items-center justify-center w-full gap-[1px] ">
          <img
            src="/goldCoin.png"
            alt=""
            className="w-6 h-6 object-contain mt-2"
          />
          <h3 className="font-main ">{item.amount}</h3>
        </div>
        <h5 className="font-main font-normal text-center w-full mt-4">
          {item.title}
        </h5>
        <p className="max-w-[80%] text-[#6D7C94] text-sm text-center mt-2">
          {item.description}
        </p>
      </div>
      <div className="w-full h-20 bg-[#F3F5F9] flex items-center justify-center">
        <button
          className="w-[70%] bg-primary1 rounded-md h-12 text-sm flex items-center justify-center text-white"
          onClick={() => setModal(true)}
        >
          Redeem
        </button>
      </div>
    </div>
  );
}

export default MilesPointsRedeemCard;
